export const SIGN_IN_FIREBASE = "@@auth/SIGN_IN_FIREBASE";
export const LOGOUT = "@@auth/LOGOUT";
export const CHANGE_NAME = "@@auth/CHANGE_NAME";
export const RECEIVE_LOGIN = "@@auth/RECEIVE_LOGIN";
export const LOGOUT_FAILED = "@@auth/LOGOUT_FAILED";

export function signIn(navigate) {
  return { type: SIGN_IN_FIREBASE, payload: { navigate } };
}

export function receiveLogin(user) {
  return { type: RECEIVE_LOGIN, payload: user };
}

export function logout() {
  return { type: LOGOUT };
}
